import { takeLatest } from 'redux-saga/effects';
import sagaActions from '../../actions/index';
import {
  campaignTableSaga,
  addCampaignSaga,
  editCampaignSaga,
  deleteCampaignSaga,
  getCampaignByIdSaga,
  generateCampaignQrSaga,
  downloadCampaignQrZipSaga,
  fetchCampaignQrListSaga,
  getQrByCodeSaga,
  getPaymentsSaga,
  downloadPaymentBatchCsvSaga,
  getcustomFarmerReportSaga,
} from './campaignTableSaga';

export function* campaignMasterSaga() {
  yield takeLatest(sagaActions.CAMPAIGNTABLE_SAGA, campaignTableSaga);
  yield takeLatest(sagaActions.GET_CAMPAIGN_BY_ID, getCampaignByIdSaga);
  yield takeLatest(sagaActions.ADD_CAMPAIGN, addCampaignSaga);
  yield takeLatest(sagaActions.EDIT_CAMPAIGN, editCampaignSaga);
  yield takeLatest(sagaActions.DELETE_CAMPAIGN, deleteCampaignSaga);
  yield takeLatest(sagaActions.GENERATE_CAMPAIGN_QR, generateCampaignQrSaga);
  yield takeLatest(sagaActions.DOWNLOAD_CAMPAIGN_QR_ZIP, downloadCampaignQrZipSaga);
  yield takeLatest(sagaActions.GET_CAMPAIGN_QR_LIST, fetchCampaignQrListSaga);
  yield takeLatest(sagaActions.GET_QR_BY_CODE, getQrByCodeSaga);
  yield takeLatest(sagaActions.SET_PAYMENT_DATA, getPaymentsSaga);
  yield takeLatest(sagaActions.DOWNLOAD_PAYMENT_BATCH_CSV, downloadPaymentBatchCsvSaga);
  yield takeLatest(sagaActions.DOWNLAOD_CUSTOM_REPORT_FARMER, getcustomFarmerReportSaga);
}
